// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__6Av9Z","inputClass":"Search_inputClass__3VzVv"};